import { render, staticRenderFns } from "./LocationMessage.vue?vue&type=template&id=01099503&scoped=true&"
import script from "./LocationMessage.vue?vue&type=script&lang=ts&"
export * from "./LocationMessage.vue?vue&type=script&lang=ts&"
import style0 from "./LocationMessage.vue?vue&type=style&index=0&id=01099503&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01099503",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardActions,VImg})
